import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, filter, map, take } from 'rxjs';
import { TenantSettingsStoreService } from 'src/app/setting/tenant-settings/services/tenant-settings-store.service';
import { isEnabledByTenantSettings } from '../helpers/route-tenant-setting';

/**
 * Blocks routes that declare `data.tenantSetting` while that tenant option is switched off, so a
 * page hidden from the settings menu cannot be reached by typing its URL either. Used next to the
 * AuthGuard, which keeps deciding on the permission.
 */
@Injectable({
  providedIn: 'root'
})
export class TenantSettingGuard {
  constructor(
    private router: Router,
    private tenantSettingsStore: TenantSettingsStoreService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    // The settings are loaded on app start and on login; wait for the first loaded value.
    return this.tenantSettingsStore.tenantSettings$.pipe(
      filter(tenantSettings => !!tenantSettings),
      take(1),
      map(tenantSettings => isEnabledByTenantSettings(route.routeConfig ?? { data: route.data }, tenantSettings)
        ? true
        : this.router.createUrlTree(['/settings']))
    );
  }
}
